import { TableColumn } from 'react-data-table-component';
import { Input, Label } from 'reactstrap';

interface IProps {
  id: string;
  name: string;
  roleId: number;
  isActive?: boolean;
  entity?: {
    id: string;
    name: string;
  };
  course?: {
    id: string;
    name: string;
  };
}

export const makeColumnsCoordinators = (
  handleActiveInactiveSwitchChangeProfile: (
    id: string,
    checked: boolean,
    roleId: number,
  ) => void,
): TableColumn<IProps>[] => {
  return [
    {
      name: 'Organização',
      selector: (row) => row.entity?.name ?? '',
      sortable: true,
      sortField: 'name',
      wrap: true,
    },
    {
      name: 'Curso',
      selector: (row) => row.course?.name ?? '',
      sortable: true,
      sortField: 'name',
      wrap: true,
    },
    {
      name: 'Perfil',
      selector: (row) => row.name,
      sortable: true,
      sortField: 'name',
      wrap: true,
    },
    {
      name: '',
      cell: (row) => (
        <div className="form-check-right form-switch form-switch-success">
          <Label className="mb-0" htmlFor={`SwitchCheck-${row.id}`}>
            {row.isActive ? 'Ativo' : 'Inativo'}
          </Label>
          <Input
            className="form-check-input"
            style={{ cursor: 'pointer' }}
            type="checkbox"
            role="switch"
            id={`SwitchCheck-${row.id}`}
            checked={row.isActive}
            onChange={(e) =>
              handleActiveInactiveSwitchChangeProfile(
                row.id,
                e.target.checked,
                row.roleId,
              )
            }
          />
        </div>
      ),
      sortable: false,
      sortField: 'name',
      wrap: true,
    },
  ];
};

/* export const makeColumnsCoordinators = (): TableColumn<IProps>[] => {
  return [
    {
      name: 'Organização',
      selector: (row) => row.entity.name,
      sortable: true,
      sortField: 'name',
      wrap: true,
    },
    {
      name: 'Curso',
      selector: (row) => row.course.name,
      sortable: true,
      sortField: 'name',
      wrap: true,
    },
    {
      name: 'Modalidade de vinculo',
      selector: (row) => row.profile.employmentRelationship,
      sortable: true,
      sortField: 'name',
      wrap: true,
    },
    {
      name: 'Carga Horaria semanal',
      selector: (row) => row.profile.workloadWeek,
      sortable: true,
      sortField: 'name',
      wrap: true,
    },
    {
      name: 'Valor',
      selector: (row) => row.profile.valueHour,
      sortable: true,
      sortField: 'name',
      wrap: true,
    },

    {
      name: 'Vigência',
      selector: (row) => row.profile.vigency,
      sortable: true,
      sortField: 'name',
      wrap: true,
    },
    {
      name: 'Gestor',
      // selector: (row) => row.profile.name,
      // sortable: true,
      // sortField: 'name',
      // wrap: true,
    },
    {
      name: 'Quantidade de estudantes assistidos',
      selector: (row) => row.profile.qtyStudents,
      sortable: true,
      sortField: 'name',
      wrap: true,
    },
  ];
};
 */
